import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye-closed",
  "use": "eye-closed-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"eye-closed\"><path d=\"M8 10c-3.555 0-5-2.5-6-4H1c1 1.833 3 5 7 5s6-3.167 7-5h-1c-1 1.5-2.445 4-6 4z\" /><path d=\"M5.219 9.746l.906.422-.964 2.067-.906-.422.964-2.067zM2.532 8l.643.766-1.532 1.286L1 9.286 2.532 8zm7.565 2.632l.907-.423.748 1.604-.907.422-.748-1.603zM13 8.766L13.643 8l1.532 1.286-.643.766L13 8.766z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol